export const formatNum2Dp = (number) => {
  if (number === 0 || number === "0") {
    return "0.00";
  }
  if (number) {
    return parseFloat(number).toFixed(2);
  }
  return "0.00";
};

export default formatNum2Dp;
